import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  htmlContentSH: null,
  loadingSH: false,
  errorSH: null
};

const storageFileSlice = createSlice({
  name: 'storageFile',
  initialState,
  reducers: {
    setHtmlContentSH: (state, action) => {
      state.htmlContentSH = action.payload;
      state.loadingSH = false;
      state.errorSH = null;
    },
    setLoadingSH: (state) => {
      state.loadingSH = true;
    },
    setErrorSH: (state, action) => {
      state.errorSH = action.payload;
      state.loadingSH = false;
    }
  }
});

export const { setHtmlContentSH, setLoadingSH, setErrorSH } = storageFileSlice.actions;
export default storageFileSlice.reducer;